module.exports = __webpack_public_path__ + "img/hotel.8bf881d5.jpg";